import { ClassData } from "../../../common/dtos/classes.type";
import { DEFAULT_CATEGORY } from "../../../common/services/default-category.service";
import {
  getDayByProperty,
  getValueByAgeCode,
} from "../../../common/utils/classes.util";
import { RYB_CLASSES_DATA } from "../../../common/utils/const.util";
import {
  additionalUrlParameters,
  parseRegistrationLink,
} from "../../../common/utils/url.util";

export function openModal(cardData: ClassData) {
  $("#base .ryb-connect-modal .modal-title").html(cardData.category2); // do not change it is passed as category2
  $("#base .ryb-connect-modal .modal-address").html(cardData.location);
  $("#base .ryb-connect-modal .modal-price").html(
    cardData.tuition.fee.toString()
  );
  $("#base .ryb-connect-modal .modal-min-age").html(
    getValueByAgeCode(cardData.min_age)
  );
  $("#base .ryb-connect-modal .modal-max-age").html(
    getValueByAgeCode(cardData.max_age)
  );
  $("#base .ryb-connect-modal .modal-gender").html(cardData.gender);
  $("#base .ryb-connect-modal .modal-meeting-day").html(
    getDayByProperty(cardData.meeting_days)
  );
  $("#base .ryb-connect-modal .modal-start-time").html(cardData.start_time);
  $("#base .ryb-connect-modal .modal-end-time").html(cardData.end_time);
  $("#base.ryb-connect-overlay").addClass("show");
  $("#base .ryb-connect-modal .modal-description").text(
    cardData.description ||
      RYB_CLASSES_DATA.classes.find(
        (item) => cardData[DEFAULT_CATEGORY] === item.name
      )?.description ||
      ""
  );

  $(".ryb-connect-overlay").on("click", function () {
    closeModal();
  });

  $("#base .ryb-connect-modal .close-modal").on("click", function () {
    closeModal();
  });

  $(".ryb-connect-overlay *").on("click", function (event) {
    event.stopPropagation();
  });

  $("button.register-now").on("click", function () {
    const fallbackUrl =
      RYB_CLASSES_DATA.classes?.find(
        (category) => category.name === cardData[DEFAULT_CATEGORY]
      )?.fallback_url || "";
    if (cardData.online_reg_link) {
      window.open(
        `${parseRegistrationLink(
          cardData.online_reg_link,
          cardData.tuition.fee.toString(),
          cardData.category1,
          cardData.category2
        )}`,
        "_blank"
      );
    } else {
      window.open(
        `${additionalUrlParameters(
          fallbackUrl,
          cardData.tuition.fee.toString(),
          cardData.category1,
          cardData.category2
        )}`,
        "_blank"
      );
    }
  });
}

export function closeModal() {
  $(".ryb-connect-overlay").removeClass("show");
}
